<form [formGroup]="editStaffForm">
  <table class="table" *ngIf="staffItem">
    <thead>
    <tr>
      <th>Vorname</th>
      <th>Nachname</th>
      <th>E-Mail</th>
      <th>Telefon</th>
      <th>PPS-ID</th>
      <th>CRM-ID</th>
      <th>CRM-Username</th>
      <th>Admin</th>
      <th>Aktiv</th>
      <th>Passwort (leer = unver&auml;ndert)</th>
      <th>Aktion</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td><input class="clr-input" formControlName="firstname"></td>
      <td><input class="clr-input" formControlName="lastname"></td>
      <td><input class="clr-input" formControlName="email"></td>
      <td><input class="clr-input" formControlName="phone"></td>
      <td><input class="clr-input" formControlName="pps_id"></td>
      <td><input class="clr-input" formControlName="crm_id"></td>
      <td><input class="clr-input" formControlName="crm_username" placeholder="z.B. t.lerche"></td>
      <td>
        <select class="clr-input" formControlName="is_admin">
          <option [ngValue]="true">ja</option>
          <option [ngValue]="false">nein</option>
        </select>
      </td>
      <td>
        <select class="clr-input" formControlName="active">
          <option [ngValue]="true">ja</option>
          <option [ngValue]="false">nein</option>
        </select>
      </td>
      <td><input class="clr-input" type="password" autocomplete="new-password" formControlName="auth_password"></td>
      <td class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateStaff()" [disabled]="editStaffForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</form>

<br />
<a class="btn btn-warning-outline btn-sm" (click)="cancelEdit()">Abbrechen</a>
